import { useMemo } from "react";

import { useSearchWheelsByVehicle } from "../../../../queries/useSearchWheelsByVehicle";
import { useWheelBrands } from "./useWheelBrands";

export const useWheelBrandOptions = (): Option[] => {
  const { data: wheels } = useSearchWheelsByVehicle({
    keepPreviousData: true,
  });
  const [brands] = useWheelBrands();

  const options = useMemo((): Option[] => {
    if (!wheels) return [];
    const acc = {} as Record<string, null>;
    for (const { partDetails } of wheels.allParts) {
      const { wheelManufacturerName } = partDetails.primaryPart;
      acc[wheelManufacturerName] = null;
    }
    const entries = Object.entries(acc);
    const result = entries
      .map(([brand]) => {
        const count = wheels.allParts.reduce(
          (acc, { partDetails }) =>
            partDetails.primaryPart.wheelManufacturerName === brand
              ? acc + 1
              : acc,
          0
        );
        const checked = brands.includes(brand);
        return { brand, checked, count };
      })
      .sort((a, b) => a.brand.localeCompare(b.brand));
    return result;
  }, [wheels?.allParts, brands]);

  return options;
};

type Option = {
  brand: string;
  checked: boolean;
  count: number;
};
